import React, { useMemo } from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { debeFiltrarPorProfesional, getUserData } from '../../../utils/userAccessHelpers';
import { useEffect, useState, useCallback } from "react";
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

function ListarPacientesCartera() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);

    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroDocumento, setFiltroDocumento] = useState('');
    const [filtroFechaIngreso, setFiltroFechaIngreso] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const [recargandoPacientes, setRecargandoPacientes] = useState(false);
    const registrosPorPagina = 10;

    const normalizarParaBusqueda = (texto) => {
        if (texto == null || texto === '') return '';
        return String(texto)
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const coincideNombreBusqueda = (nombreCompleto, filtro) => {
        const termino = normalizarParaBusqueda(filtro);
        if (!termino) return true;
        const base = normalizarParaBusqueda(nombreCompleto);
        if (base.includes(termino)) return true;
        const palabras = termino.split(' ').filter(Boolean);
        return palabras.every((palabra) => base.includes(palabra));
    };

    const getNombre = (nombre) => (nombre != null ? nombre : '');

    const getNombreCompleto = (row) => {
        return [
            row.primer_nombre,
            getNombre(row.segundo_nombre),
            row.primer_apellido,
            getNombre(row.segundo_apellido)
        ]
            .map((parte) => (parte != null ? String(parte).trim() : ''))
            .filter((parte) => parte !== '')
            .join(' ');
    };

    const getBotones = (item) => (
        <Link
            to={'/estado-cuenta-paciente?id=' + item.id}
            className="btn btn-sm patient-cartera-btn"
            title="Ver cartera"
        >
            <i className="fas fa-dollar-sign mr-1"></i>
            Cartera
        </Link>
    );

    const cols = [
        {
            name: 'Nombre',
            selector: row => getNombreCompleto(row),
            sortable: true,
            grow: 1.6,
            cell: row => <span className="patient-name-cell" title={getNombreCompleto(row)}>{getNombreCompleto(row)}</span>
        },
        { name: 'Documento', selector: row => row.numero_documento, sortable: false, grow: 0.9 },
        { name: 'Email', selector: row => row.email, sortable: false, grow: 1.1 },
        { name: 'Celular', selector: row => row.celular, sortable: false, grow: 0.85 },
        { name: 'Acción', center: true, cell: row => getBotones(row), grow: 0.75 }
    ];

    const customTableStyles = useMemo(() => ({
        table: { style: { backgroundColor: '#fff' } },
        headRow: {
            style: {
                minHeight: '44px',
                borderBottom: '1px solid #e9eef3',
                backgroundColor: '#fafcfe'
            }
        },
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 700,
                color: '#5f6b77',
                textTransform: 'uppercase',
                letterSpacing: '0.02em',
                paddingTop: '10px',
                paddingBottom: '10px'
            }
        },
        rows: {
            style: {
                minHeight: '52px',
                borderBottom: '1px solid #f1f4f8'
            }
        },
        cells: {
            style: {
                fontSize: '13px',
                color: '#2f3a45'
            }
        },
        pagination: {
            style: {
                borderTop: '1px solid #eef2f6',
                minHeight: '50px'
            }
        }
    }), []);

    const usuarioTienePermisoFacturacion = (userdata) => {
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            return userdata.permissions.some(permission =>
                permission.slug === 'ver_listado_presupuestos'
                || permission.slug === 'ver_listado_facturas'
                || permission.slug === 'ver_listado_documentos_soporte'
            );
        }
        if (userdata.up) {
            return userdata.up.includes('ver_listado_presupuestos')
                || userdata.up.includes('ver_listado_facturas')
                || userdata.up.includes('ver_listado_documentos_soporte');
        }
        return false;
    };

    const cargarPacientes = useCallback(() => {
        const userdataActual = getUserData();
        if (!userdataActual?.user_id) {
            return Promise.resolve();
        }

        const parametrosFiltro = {
            uid: userdataActual.user_id,
            solo_pacientes: true,
        };

        if (debeFiltrarPorProfesional(userdataActual)) {
            parametrosFiltro.solo_mis_pacientes = true;
        }

        setRecargandoPacientes(true);

        return axios.get('/pacientes', { params: parametrosFiltro })
            .then((response) => {
                if (response.status === 200) {
                    setItems(response.data);
                    setPaginaActual(1);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setRecargandoPacientes(false);
            });
    }, []);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        if (!usuarioTienePermisoFacturacion(userdata)) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
                setLoggedIn(true);
            });

        cargarPacientes();
    }, [cargarPacientes]);

    useEffect(() => {
        const onVistaPiChanged = () => {
            cargarPacientes();
        };
        window.addEventListener('smile-vista-pi-changed', onVistaPiChanged);
        return () => window.removeEventListener('smile-vista-pi-changed', onVistaPiChanged);
    }, [cargarPacientes]);

    const itemsFiltrados = useMemo(() => {
        const nombreFiltro = filtroNombre.trim();
        const documentoFiltro = normalizarParaBusqueda(filtroDocumento).replace(/\s/g, '');
        const fechaFiltro = filtroFechaIngreso;

        return items.filter((item) => {
            const nombreCompleto = getNombreCompleto(item);
            const numeroDocumento = normalizarParaBusqueda(item.numero_documento || '').replace(/\s/g, '');
            const fechaIngreso = item.fechaingreso ? item.fechaingreso.slice(0, 10) : '';

            const coincideNombre = coincideNombreBusqueda(nombreCompleto, nombreFiltro);
            const coincideDocumento = !documentoFiltro || numeroDocumento.includes(documentoFiltro);
            const coincideFecha = !fechaFiltro || fechaIngreso === fechaFiltro;

            return coincideNombre && coincideDocumento && coincideFecha;
        });
    }, [items, filtroNombre, filtroDocumento, filtroFechaIngreso]);

    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const pacientesPaginados = itemsFiltrados.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(itemsFiltrados.length / registrosPorPagina);

    const cambiarPagina = (numeroPagina) => {
        if (numeroPagina < 1 || numeroPagina > totalPaginas) return;
        setPaginaActual(numeroPagina);
    };

    const getPaginationItems = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
        if (current <= 4) return [1, 2, 3, 4, '...', total];
        if (current >= total - 3) return [1, '...', total - 3, total - 2, total - 1, total];
        return [1, '...', current - 1, current, current + 1, '...', total];
    };

    const nuevosMes = useMemo(() => {
        const hoy = new Date();
        const mesActual = hoy.getMonth();
        const anioActual = hoy.getFullYear();

        return items.filter((item) => {
            if (!item.fechaingreso) return false;
            const fecha = new Date(item.fechaingreso);
            return fecha.getMonth() === mesActual && fecha.getFullYear() === anioActual;
        }).length;
    }, [items]);

    const pacientesConEmail = useMemo(() => items.filter(item => !!item.email).length, [items]);
    const pacientesCompletos = useMemo(() => items.filter(item => String(item.estado) !== '0').length, [items]);

    useEffect(() => {
        setPaginaActual(1);
    }, [filtroNombre, filtroDocumento, filtroFechaIngreso]);

    useEffect(() => {
        if (totalPaginas > 0 && paginaActual > totalPaginas) {
            setPaginaActual(totalPaginas);
        }
    }, [paginaActual, totalPaginas]);

    if (loggedIn && hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn && hasPermission) {
        return (
            <div className="hold-transition patient-list-page">
                <Header client={client} />
                <Aside client={client} activelink="billing" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item active">Estado de Cuenta Paciente</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-12 d-flex flex-wrap align-items-center justify-content-between">
                                    <h1 className="m-0 patient-main-title">Estado de Cuenta Paciente</h1>
                                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                                        <span className="badge patient-soft-badge">
                                            {itemsFiltrados.length} registros
                                        </span>
                                        <span className="badge patient-soft-badge patient-soft-badge--teal">
                                            +{nuevosMes} nuevos este mes
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row patient-filters-row">
                                <div className="col-12 mb-3">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-users"></i></div>
                                                <div className="patient-kpi-value">{items.length}</div>
                                                <div className="patient-kpi-label">Total pacientes</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-user-plus"></i></div>
                                                <div className="patient-kpi-value">{nuevosMes}</div>
                                                <div className="patient-kpi-label">Nuevos este mes</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-envelope"></i></div>
                                                <div className="patient-kpi-value">{pacientesConEmail}</div>
                                                <div className="patient-kpi-label">Con email</div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <div className="patient-kpi-card">
                                                <div className="patient-kpi-icon"><i className="fas fa-user-check"></i></div>
                                                <div className="patient-kpi-value">{pacientesCompletos}</div>
                                                <div className="patient-kpi-label">Perfiles completos</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="patient-filters-box">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="form-group patient-filter-group">
                                                    <label htmlFor="filtroNombre">Nombre</label>
                                                    <input
                                                        type="text"
                                                        id="filtroNombre"
                                                        className="form-control"
                                                        placeholder="Buscar por nombre..."
                                                        value={filtroNombre}
                                                        onChange={(e) => setFiltroNombre(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="form-group patient-filter-group">
                                                    <label htmlFor="filtroDocumento">Documento</label>
                                                    <input
                                                        type="text"
                                                        id="filtroDocumento"
                                                        className="form-control"
                                                        placeholder="Buscar por documento..."
                                                        value={filtroDocumento}
                                                        onChange={(e) => setFiltroDocumento(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="form-group patient-filter-group">
                                                    <label htmlFor="filtroFechaIngreso">Fecha de ingreso</label>
                                                    <input
                                                        type="date"
                                                        id="filtroFechaIngreso"
                                                        className="form-control"
                                                        value={filtroFechaIngreso}
                                                        onChange={(e) => setFiltroFechaIngreso(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12" style={{ boxShadow: '0 0 14px rgba(0,0,0,0.09)', backgroundColor: 'white' }}>
                                    <DataTable
                                        columns={cols}
                                        data={pacientesPaginados}
                                        customStyles={customTableStyles}
                                        noDataComponent="No hay registros para mostrar"
                                        progressPending={recargandoPacientes}
                                        id="tabla-pacientes-cartera"
                                    />

                                    <div className="d-flex justify-content-between align-items-center px-3 py-3 flex-wrap" style={{ gap: '12px', borderTop: '1px solid #eef2f6' }}>
                                        <div className="text-muted" style={{ fontSize: '0.86rem' }}>
                                            {itemsFiltrados.length > 0 ? (
                                                <>
                                                    Mostrando <strong>{indicePrimerRegistro + 1}</strong> a <strong>{Math.min(indiceUltimoRegistro, itemsFiltrados.length)}</strong> de <strong>{itemsFiltrados.length}</strong> pacientes
                                                </>
                                            ) : (
                                                <>Mostrando 0 de 0 pacientes</>
                                            )}
                                        </div>

                                        {totalPaginas > 1 && (
                                            <nav>
                                                <ul className="pagination pagination-sm mb-0" style={{ gap: '5px' }}>
                                                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                        <button className="page-link border-0 shadow-sm" onClick={() => cambiarPagina(paginaActual - 1)} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                            ‹
                                                        </button>
                                                    </li>

                                                    {getPaginationItems(paginaActual, totalPaginas).map((item, idx) => {
                                                        if (item === '...') {
                                                            return (
                                                                <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                                    <span className="page-link border-0 bg-transparent">...</span>
                                                                </li>
                                                            );
                                                        }
                                                        return (
                                                            <li key={item} className={`page-item ${paginaActual === item ? 'active' : ''}`}>
                                                                <button
                                                                    className="page-link border-0 shadow-sm"
                                                                    onClick={() => cambiarPagina(item)}
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        padding: '6px 12px',
                                                                        background: paginaActual === item ? '#17a2b8' : '#f8f9fa',
                                                                        color: paginaActual === item ? 'white' : '#323a45',
                                                                        fontWeight: paginaActual === item ? '600' : '500'
                                                                    }}
                                                                >
                                                                    {item}
                                                                </button>
                                                            </li>
                                                        );
                                                    })}

                                                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                        <button className="page-link border-0 shadow-sm" onClick={() => cambiarPagina(paginaActual + 1)} style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}>
                                                            ›
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} />

                <style>{`
                    .patient-list-page .patient-main-title {
                        font-size: 1.55rem !important;
                        font-weight: 700 !important;
                        color: #2b3440 !important;
                    }
                    .patient-list-page .patient-soft-badge {
                        background: rgba(23, 162, 184, 0.13);
                        color: #12798a;
                        border: 1px solid rgba(23, 162, 184, 0.25);
                        border-radius: 999px;
                        font-weight: 700;
                        padding: 0.34rem 0.65rem;
                        font-size: 0.76rem;
                    }
                    .patient-list-page .patient-soft-badge--teal {
                        background: rgba(40, 167, 69, 0.11);
                        color: #1f7d46;
                        border-color: rgba(40, 167, 69, 0.2);
                    }
                    .patient-list-page .patient-name-cell {
                        font-weight: 600;
                        color: #26313b;
                    }
                    .patient-list-page .patient-kpi-card {
                        background: #fff;
                        border: 1px solid #e8edf2;
                        border-radius: 14px;
                        padding: 14px 16px;
                        box-shadow: 0 6px 16px rgba(29, 45, 61, 0.05);
                    }
                    .patient-list-page .patient-kpi-icon {
                        width: 34px;
                        height: 34px;
                        border-radius: 10px;
                        background: rgba(23, 162, 184, 0.12);
                        color: #168394;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 8px;
                    }
                    .patient-list-page .patient-kpi-value {
                        font-size: 1.45rem;
                        line-height: 1.1;
                        font-weight: 700;
                        color: #26323f;
                    }
                    .patient-list-page .patient-kpi-label {
                        font-size: 0.8rem;
                        color: #70808f;
                        font-weight: 600;
                    }
                    .patient-list-page .patient-cartera-btn {
                        border-radius: 8px;
                        font-weight: 600;
                        font-size: 12px;
                        color: #0f7281;
                        border: 1px solid rgba(17, 160, 180, 0.28);
                        background: rgba(17, 160, 180, 0.1);
                        white-space: nowrap;
                    }
                    .patient-list-page .patient-cartera-btn:hover {
                        color: #0a5c68;
                        background: rgba(17, 160, 180, 0.18);
                        border-color: rgba(17, 160, 180, 0.4);
                        text-decoration: none;
                    }
                    .patient-list-page .patient-filters-row {
                        display: flex;
                        align-items: flex-end;
                    }
                    .patient-list-page .patient-filters-box {
                        background: #fff;
                        border: 1px solid #e8edf2;
                        border-radius: 12px;
                        padding: 12px 12px 10px;
                        margin-bottom: 10px;
                        box-shadow: 0 4px 12px rgba(29, 45, 61, 0.04);
                    }
                    .patient-list-page .patient-filter-group {
                        margin-bottom: 0;
                    }
                    .patient-list-page .patient-filter-group label {
                        min-height: 22px;
                        display: inline-flex;
                        align-items: flex-end;
                        margin-bottom: 0.45rem;
                    }
                    .patient-list-page .patient-filter-group input.form-control {
                        min-height: 38px;
                        box-sizing: border-box;
                    }
                    .patient-list-page .patient-filter-group input[type="date"].form-control {
                        line-height: 1.25;
                    }
                    @media (max-width: 768px) {
                        .patient-list-page .patient-kpi-card {
                            padding: 12px 14px;
                        }
                    }
                `}</style>
            </div>
        );
    }

    return <Loading />;
}

export default ListarPacientesCartera;
